import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
// import offImg1 from "../../Images/offerimg/Planet.png";
// import offImg2 from "../../Images/offerimg/Resto.png";
// import offImg3 from "../../Images/offerimg/Thumbay Hospital.png";
// import offImg4 from "../../Images/offerimg/Times College.png";
// import offImg5 from "../../Images/logo-w.png";
import { useDispatch, useSelector } from "react-redux";
import { OurPartNerAllOffer } from "../../Redux/Slice/Offer";
import NoRecordFoundMessage from "../OwnContactlist/NoRecordFound";

function TopredeemedOffers() {
  const { OurPartNerData } = useSelector((state) => state.offer);
  const { UserProfileID } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(OurPartNerAllOffer());
  }, []);

  const visibleOffers = (OurPartNerData || []).filter(
    (item) => !item?.purchasedStatus && UserProfileID?._id !== item?.partnerId
  );

  return (
    <>
      <section className="topredeemedOffers_sec">
        <h4 className="heading">Recent offers</h4>
        {visibleOffers.length == 0 && (
          <NoRecordFoundMessage message="No offer available!" />
        )}
        <ul>
          {visibleOffers.map((item, index) => (
            <li className="cardbox_box" key={index}>
              <div className="row m-0">
                <div className="col-xl-4 col-lg-4 col-md-5 col-sm-5 col-5 p-0">
                  <div
                    className="img_box"
                    style={{ backgroundColor: item.bgColor, cursor: "pointer" }}
                    onClick={() => navigate("/offers-categories-details/" +
                      item?.offerCategory?.toLowerCase() +
                      "/" +
                      item?._id)}
                  >
                    <img
                      src={item?.partnerLogo}
                      className="img-fluid p-2"
                      alt="..."
                    />
                  </div>
                </div>
                <div className="col-xl-8 col-lg-8 col-md-7 col-sm-7 col-7 pr-0">
                  <div className="content">
                    <h4 className="name">{item.companyName}</h4>
                    <h6 className="status">{item.offerType}</h6>
                    <div className="flex_wrap">
                      <p className="text">
                      </p>                      {item.partnerEmirate} - {item.partnerCountry}

                    </div>

                    <div className="flex_wrap">
                      <p className="point">
                        <span>{item?.reddemingPoints}</span>Redeeming points
                      </p>
                      {item?.purchasedStatus ? (
                        <div
                          // to={"/offers-categories-details/" + item?._id}
                          className="OfferdetailsRedeemed_btn"
                        >
                          Already Redeemed
                        </div>
                      ) : item?.voucherCount >= item?.voucherNo ? (
                        <div
                          // to={"/offers-categories-details/" + item?._id}
                          className="OfferdetailsRedeemed_btn"
                        >
                          Expired
                        </div>
                      ) : (
                        <Link
                          to={
                            "/offers-categories-details/" +
                            item?.offerCategory?.toLowerCase() +
                            "/" +
                            item?._id
                          }
                          className="Offerdetails_btn"
                        >
                          Offer details
                          <i className="fa-regular fa-circle-right"></i>
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
}

export default TopredeemedOffers;
